module.exports = __webpack_public_path__ + "img/west-vvip-gal-9.2a81b876.jpg";